module.exports = __webpack_public_path__ + "static/img/slytyy.8058554.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/slytyy.png
// module id = Ykbz
// module chunks = 0